import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ICardSelect } from '../../interfaces/ICardSelect.interface';
import { ICheckForCardRequest, RequestMode } from '../../interfaces/ICheckForCardRequest.interface';
import { IContentResponse } from '../../interfaces/IContentResponse.interface';
import { DirectDebitService } from '../../services/direct-debit.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GtmService } from '../../../../shared/cardholders-core/services/gtm.service';
import { UiHelperService } from '../../../../shared/cardholders-core/services/ui-helper.service';
import { AppConfigsService } from 'ClientApp/app/config/app-configs.service';

@Component({
    selector: 'app-check-for-card',
    templateUrl: './check-for-card.component.html',
    styleUrls: ['./check-for-card.component.scss']
})
export class CheckForCardComponent implements OnInit, OnDestroy {
    subs: Subscription[] = [];
    userCards: ICardSelect[] = [];
    request: ICheckForCardRequest;
    contents: IContentResponse;
    displayBenefit: boolean;
    constructor(
        private directDebSrv: DirectDebitService,
        private activeRoute: ActivatedRoute,
        private uiHelper: UiHelperService,
        private router: Router,
        private config: AppConfigsService,
        private gtmService: GtmService
    ) {}
    get bgImg(): string {
        return `url(${
            this.uiHelper.IsMobile()
                ? this.contents.homePage.headerMobileImage
                : this.contents.homePage.headerDesktopImage
        }) 0% 0%  no-repeat`;
    }
    ngOnInit(): void {
        this.directDebSrv.getContent().subscribe((res) => {
            if (res.returnCode === 0) {
                if (this.config.appConfigs.FLAG_ISOpenDropdownInDirectDebit) {
                    this.userCards = res.result.userCard;
                }
                this.displayBenefit = res.result.displayBenefit;
            } else {
                this.directDebSrv.rcError = res.returnCode;
                this.directDebSrv.fromError = 'getContentAndData';
                this.directDebSrv.next = 'error';
                this.router.navigate(['../error'], { relativeTo: this.activeRoute });
            }
        });
        this.subs.push(
            this.directDebSrv.contents$.subscribe((contents) => {
                if (contents) {
                    this.contents = contents;
                    this.parseClassLink();
                }
            })
        );

        this.directDebSrv.isHokBebefit = this.activeRoute.snapshot.queryParams['addbenefit'] === 'true';
        this.gtmService.pushDirectDebit('phase1', 'load');
    }
    parseClassLink() {
        this.contents.homePage.cubes.forEach((cube) => {
            cube.class = cube.imageLink.substring(cube.imageLink.lastIndexOf('/') + 1, cube.imageLink.lastIndexOf('.'));
        });
    }
    onSelect(r: ICheckForCardRequest) {
        this.request = r;
    }

    ngOnDestroy(): void {
        this.subs.forEach((x) => x.unsubscribe());
    }
}
